export default "__VITE_ASSET__1f90cacd__"